export default __webpack_public_path__ + "static/media/FreightSmith_WORDMARK_blue.fd3277fc.png";